import React from 'react';
import { UseAppSelector } from '../../../../store/hooks';
import Fade from 'react-reveal/Fade';
import FormatCurrency from '../../../../scripts/formatCurrency';

import '../../../../styles/desktop/calculators/sub_components/costsOutput.css';

function CostsOutput() {
    // redux
    const statsEngine = UseAppSelector((state) => state.stats);
    const TC = statsEngine.find(item => item.title === 'total-cost');
    const UC = statsEngine.find(item => item.title === 'upgrades-cost');
    const PP = statsEngine.find(item => item.title === 'payback-period');

    return (
        <section className="costs-section">
            <Fade right cascade>
                <div className="costs-parent">
                    <div className="costs-card">
                        <label className="costs-title">Total Cost</label>
                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" className="bi bi-arrow-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                        </svg>
                        <label className="costs-data">GTA {FormatCurrency(TC.value)}</label>
                    </div>
                    <div className="costs-card">
                        <label className="costs-title">Upgrades Cost</label>
                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" className="bi bi-arrow-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                        </svg>
                        <label className="costs-data">GTA {FormatCurrency(UC.value)}</label>
                    </div>
                    <div className="costs-card">
                        <label className="costs-title">Payback Period</label>
                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" className="bi bi-arrow-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                        </svg>
                        <label className="costs-data">{PP.value} Hours</label>
                    </div>
                </div>
            </Fade>

        </section>
    )
}

export default CostsOutput;
